
    import { defineComponent, PropType } from "vue"

    export default defineComponent({
        props: {
            result: String,

        },
        components: {

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {

            }
        },
        computed: {
            segments(): {isCode?: boolean, text: string}[] {
                const divider = "`" + "`" + "`"
                return this.result?.split(divider)?.map((dividerOne, i) => ({ isCode: !!(i % 2), text: dividerOne.trim() })) || []
            },
        },
        methods: {

        },
    })

    